/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getIntegrationEndpoints } from 'app/entities/integration-endpoint/integration-endpoint.reducer';
import { getEntities as getIntegrationEndpointAttributes } from 'app/entities/integration-endpoint-attribute/integration-endpoint-attribute.reducer';
import { getEntities as getTenantIntegrationEndpointAttributes } from 'app/entities/tenant-integration-endpoint-attribute/tenant-integration-endpoint-attribute.reducer';
import { createEntity, getEntity, reset, updateEntity } from './integration-endpoint-attribute.reducer';

export const IntegrationEndpointAttributeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const integrationEndpoints = useAppSelector(state => state.integrationEndpoint.entities);
  const integrationEndpointAttributes = useAppSelector(state => state.integrationEndpointAttribute.entities);
  const tenantIntegrationEndpointAttributes = useAppSelector(state => state.tenantIntegrationEndpointAttribute.entities);
  const integrationEndpointAttributeEntity = useAppSelector(state => state.integrationEndpointAttribute.entity);
  const loading = useAppSelector(state => state.integrationEndpointAttribute.loading);
  const updating = useAppSelector(state => state.integrationEndpointAttribute.updating);
  const updateSuccess = useAppSelector(state => state.integrationEndpointAttribute.updateSuccess);

  const handleClose = () => {
    navigate(`/integration-endpoint-attribute${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getIntegrationEndpoints({}));
    dispatch(getIntegrationEndpointAttributes({}));
    dispatch(getTenantIntegrationEndpointAttributes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...integrationEndpointAttributeEntity,
      ...values,
      coFormat: clinicalDictionaries.find(it => it.id.toString() === values.coFormat?.toString()),
      ciFormat: clinicalDictionaries.find(it => it.id.toString() === values.ciFormat?.toString()),
      attributeType: clinicalDictionaries.find(it => it.id.toString() === values.attributeType?.toString()),
      valueType: clinicalDictionaries.find(it => it.id.toString() === values.valueType?.toString()),
      valueRange: clinicalDictionaries.find(it => it.id.toString() === values.valueRange?.toString()),
      endpoint: integrationEndpoints.find(it => it.id.toString() === values.endpoint?.toString()),
      parent: integrationEndpointAttributes.find(it => it.id.toString() === values.parent?.toString()),
      tenantAttribute: tenantIntegrationEndpointAttributes.find(it => it.id.toString() === values.tenantAttribute?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...integrationEndpointAttributeEntity,
          coFormat: integrationEndpointAttributeEntity?.coFormat?.id,
          ciFormat: integrationEndpointAttributeEntity?.ciFormat?.id,
          attributeType: integrationEndpointAttributeEntity?.attributeType?.id,
          valueType: integrationEndpointAttributeEntity?.valueType?.id,
          valueRange: integrationEndpointAttributeEntity?.valueRange?.id,
          endpoint: integrationEndpointAttributeEntity?.endpoint?.id,
          parent: integrationEndpointAttributeEntity?.parent?.id,
          tenantAttribute: integrationEndpointAttributeEntity?.tenantAttribute?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.integrationEndpointAttribute.home.createOrEditLabel"
            data-cy="IntegrationEndpointAttributeCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.home.createOrEditLabel">
              Create or edit a IntegrationEndpointAttribute
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="integration-endpoint-attribute-id"
                  label={translate('tinyMedicRestApp.integrationEndpointAttribute.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.name')}
                id="integration-endpoint-attribute-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <UncontrolledTooltip target="nameLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.name" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.defaultValue')}
                id="integration-endpoint-attribute-defaultValue"
                name="defaultValue"
                data-cy="defaultValue"
                type="text"
              />
              <UncontrolledTooltip target="defaultValueLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.defaultValue" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.example')}
                id="integration-endpoint-attribute-example"
                name="example"
                data-cy="example"
                type="text"
              />
              <UncontrolledTooltip target="exampleLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.example" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.mandatory')}
                id="integration-endpoint-attribute-mandatory"
                name="mandatory"
                data-cy="mandatory"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="mandatoryLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.mandatory" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.userSpecific')}
                id="integration-endpoint-attribute-userSpecific"
                name="userSpecific"
                data-cy="userSpecific"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="userSpecificLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.userSpecific" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.active')}
                id="integration-endpoint-attribute-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.cursor')}
                id="integration-endpoint-attribute-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.lastUpdated')}
                id="integration-endpoint-attribute-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.microSec')}
                id="integration-endpoint-attribute-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.timestampEntry')}
                id="integration-endpoint-attribute-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.integrationEndpointAttribute.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="integration-endpoint-attribute-coFormat"
                name="coFormat"
                data-cy="coFormat"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.coFormat')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="integration-endpoint-attribute-ciFormat"
                name="ciFormat"
                data-cy="ciFormat"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.ciFormat')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="integration-endpoint-attribute-attributeType"
                name="attributeType"
                data-cy="attributeType"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.attributeType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="integration-endpoint-attribute-valueType"
                name="valueType"
                data-cy="valueType"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.valueType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="integration-endpoint-attribute-valueRange"
                name="valueRange"
                data-cy="valueRange"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.valueRange')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="integration-endpoint-attribute-endpoint"
                name="endpoint"
                data-cy="endpoint"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.endpoint')}
                type="select"
              >
                <option value="" key="0" />
                {integrationEndpoints
                  ? integrationEndpoints.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="integration-endpoint-attribute-parent"
                name="parent"
                data-cy="parent"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.parent')}
                type="select"
              >
                <option value="" key="0" />
                {integrationEndpointAttributes
                  ? integrationEndpointAttributes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="integration-endpoint-attribute-tenantAttribute"
                name="tenantAttribute"
                data-cy="tenantAttribute"
                label={translate('tinyMedicRestApp.integrationEndpointAttribute.tenantAttribute')}
                type="select"
              >
                <option value="" key="0" />
                {tenantIntegrationEndpointAttributes
                  ? tenantIntegrationEndpointAttributes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/integration-endpoint-attribute"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntegrationEndpointAttributeUpdate;
